import { assert, isDefined } from '@sama/js-core';
import { isEqual, pick } from 'lodash';
import { ObjectState } from '../../../../../cross-team-shared/annotation/shared/state/object-state';
import { UpsertObjectOperation } from '../../../../../team-apis/otterdam/annotation-operations/object-operations';
import { ObjectOperationBuilderParams } from './object-operation-builder-params';

export class UpsertObjectOperationBuilder {
  private currentObject?: ObjectState;
  private previousObject?: ObjectState;

  constructor({ currentObject, previousObject }: ObjectOperationBuilderParams) {
    this.currentObject = currentObject;
    this.previousObject = previousObject;
  }

  canBuild() {
    const areObjectsDifferent = !isEqual(
      pick(this.currentObject, ['parentId', 'sortIndex', 'tags', 'class']),
      pick(this.previousObject, ['parentId', 'sortIndex', 'tags', 'class']),
    );
    return isDefined(this.currentObject) && areObjectsDifferent;
  }

  build(): UpsertObjectOperation {
    assert(
      this.currentObject,
      'currentObject should be defined for upsert operation',
    );
    return {
      operation: 'UPSERT_OBJECT',
      ids: { objectId: this.currentObject.index },
      attributes: {
        parentId: this.currentObject.parentId,
        sortIndex: this.currentObject.sortIndex,
        tags: this.currentObject.tags,
        className: this.currentObject.class,
      },
    };
  }
}
